import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { listBranches } from "./directory";
import { useAuth } from "../context/AuthContext";
import { localName } from "../lib/localName";

const cache = { list: null };

// اسم فرع الموظف لعرضه أسفل اسم الشركة في الشريط الأعلى.
export const useMyBranchName = () => {
  const { i18n } = useTranslation();
  const { user } = useAuth();
  const [branches, setBranches] = useState(cache.list);

  useEffect(() => {
    if (cache.list || !user) return;
    listBranches()
      .then((list) => {
        cache.list = list;
        setBranches(list);
      })
      .catch(() => setBranches([]));
  }, [user]);

  const mine = (user?.branch_ids || [])[0];
  const branch = (branches || []).find((b) => b.id === mine) || null;
  if (!branch) return null;
  return {
    name: localName(branch),
    isHeadOffice: Boolean(branch.is_head_office),
  };
};

export const clearBranchNameCache = () => {
  cache.list = null;
};
